import { Badge } from '@shared/components';
import { AgreementHeaderLayout } from '../AgreementHeaderLayout';
import { thirdPartyBalanceText, thirdPartyStartDateText } from '../../utils/thirdPartyAgreementView';
import type { ThirdPartyAgreement } from '../../types/thirdPartyAgreement.types';

interface Props {
    agreement: ThirdPartyAgreement;
}

export function ThirdPartyAgreementHeader({ agreement }: Props) {
    return (
        <AgreementHeaderLayout
            reference={agreement.reference}
            badges={
                <>
                    {agreement.status !== null && <Badge variant="outline">{agreement.status}</Badge>}
                    <Badge size="xs" variant="info">
                        Third Party
                    </Badge>
                </>
            }
            startDate={thirdPartyStartDateText(agreement.startDate)}
            availableBalance={thirdPartyBalanceText(agreement.balanceGrossMinor)}
        />
    );
}
